import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { ButtonVariant } from "../../../../components/button/button.constants";
import { simpleDateFromTimestamp } from "../../../../helpers/date";
import { AppConfig } from "../../../../appConfig";
import { isFullUrl } from '../../../../utils';
import PlaceholderImg from '../../../../images/defaultPlaceholder.jpg';
import {
  ListMobileProp,
  ListMobilePropText,
  ListMobilePropTitle,
  ListMobileDownloadButton,
  ListMobileDownloadIcon,
} from "../filesToDownload/filesToDownload.styled";
import { getUriType } from "../passHistory/passHistory.utils";
import { downloadByFileType } from "../../../../api/requests";

import {
  Container,
  Header,
  Thumbnail,
  HeaderText,
  Time,
  TimeIcon,
  Title,
} from "./passItemMobile.styled";

export const PassItemMobile = ({
  className,
  id,
  title,
  minutes,
  type,
  imageSrc,
  passTimestamp,
}) => {
  const { t } = useTranslation();
  const date = simpleDateFromTimestamp(passTimestamp);
  const uriType = getUriType(type.type);
  const [currentImg, setCurrentImg] = useState(() => isFullUrl(imageSrc) ? imageSrc : `${AppConfig.content}${imageSrc}`);

  const handleDownload = () => {
    downloadByFileType(uriType, id);
  };

  return (
    <Container className={className}>
      <Header>
        <Thumbnail onError={() => setCurrentImg(PlaceholderImg)} src={currentImg} />
        <HeaderText>
          <Time>
            <TimeIcon />
            {minutes} {t("idd.passItemMobile.minutes")}
          </Time>
          <Title>{title}</Title>
        </HeaderText>
      </Header>
      <ListMobileProp>
        <ListMobilePropTitle>{t("idd.passItemMobile.type")}</ListMobilePropTitle>
        <ListMobilePropText>{type.label}</ListMobilePropText>
      </ListMobileProp>
      <ListMobileProp>
        <ListMobilePropTitle>{t("idd.passItemMobile.passDate")}</ListMobilePropTitle>
        <ListMobilePropText>{date}</ListMobilePropText>
      </ListMobileProp>
      <ListMobileDownloadButton
        variant={ButtonVariant.Outlined}
        onClick={handleDownload}
        disabled={!uriType}
      >
        <ListMobileDownloadIcon />
        {t("idd.passItemMobile.download")}
      </ListMobileDownloadButton>
    </Container>
  );
};
